var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_332_1420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 10,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4196 0L4.58789 0L4.58789 18H13.4196L13.4196 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_332_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1472 16.263L6.96957 9.1089L12.9888 1.7181C13.1577 1.52912 13.2501 1.28396 13.248 1.0305C13.2498 0.760148 13.1447 0.500041 12.9555 0.3069C12.8627 0.210809 12.7518 0.134175 12.6291 0.0814786C12.5064 0.0287824 12.3744 0.00108279 12.2409 0C12.1048 0.00275406 11.9706 0.0324923 11.8461 0.0874911C11.7215 0.14249 11.6092 0.221656 11.5155 0.3204L4.85547 8.4348C4.67884 8.62766 4.58185 8.88029 4.58402 9.1418C4.58619 9.40332 4.68737 9.65429 4.86717 9.8442L11.7072 17.6868C11.7984 17.7857 11.9092 17.8647 12.0325 17.9187C12.1558 17.9727 12.289 18.0006 12.4236 18.0006C12.5582 18.0006 12.6913 17.9727 12.8146 17.9187C12.9379 17.8647 13.0487 17.7857 13.14 17.6868C13.3182 17.4933 13.4179 17.2402 13.4196 16.9771C13.4212 16.714 13.3248 16.4597 13.149 16.2639",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.cde5f7a0156419f96cc91d2dba2ce6e2.svg";
export { ForwardRef as ReactComponent };